import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchQueryList } from "./actions";
import QueriesTable from "../../components/queriesTable";

const Queries = () => {
  const dispatch = useDispatch();
  const { pageNo, limit, sortOrder, sortBy, status } = useSelector(
    (state) => state.QueriesReducer
  );

  useEffect(() => {
    dispatch(fetchQueryList());
  }, [pageNo, limit, sortOrder, sortBy, status]);

  return (
    <div>
      <QueriesTable />
    </div>
  );
};

export default Queries;
